<template lang="pug">
  bloco#arquivos.-padding-desktop
    //- HEADER
    template(slot="header")
      titulo.-withbar {{ titulo }}
      p Aqui você encontrará os documentos para download
    //- CONTENT
    .conteudo(slot="content")
      listagem(:itens="arquivos")
        arquivo(slot-scope="arquivo" :arquivo="arquivo")
    //- FEEDBACK
    template(slot="feedback", v-if="naoTemDocumentos")
      mensagem.-warn
        p Nenhum documento foi encontrado no momento
    //- FOOTER
    footer(slot="footer")
      back-and-share
</template>

<script>
import BackAndShare from 'COMPONENTS/BackAndShare'
import Bloco from 'COMPONENTS/Bloco'
import DocumentoService from '../../js/api/DocumentoService'
import Mensagem from 'COMPONENTS/Mensagem'
import Titulo from 'COMPONENTS/ElementTitle'
import Lista from 'COMPONENTS/BaseLista'
import Listagem from 'COMPONENTS/BaseListagem'
import Arquivo from 'COMPONENTS/BaseLinkDocumento'

export default {
  components: {
    Arquivo,
    BackAndShare,
    Bloco,
    Mensagem,
    Titulo,
    Lista,
    Listagem
  },
  data () {
    return {
      arquivos: [],
      categoria: 0,
      categoria_id: null,
      titulo: '',
      naoTemDocumentos: false,
      unidade: 'proad'
    }
  },
  methods: {
    loadDocumentos (categoria) {
      let documentosData = []
      DocumentoService.getDocumentos(categoria, this.unidade)
      .then(documentos => {
        documentos.data.forEach(function (documento) {
          documentosData.push({
            id: documento.id,
            nome: documento.title.rendered,
            url: documento.acf.arquivo,
            desc: documento.acf.descricao
          })
        })
        if (documentosData.length === 0) {
          this.naoTemDocumentos = true
        } else {
          this.categoria_id = documentos.data[0].categoria_documento[0]
          this.setCategoriaNome(this.categoria_id)
        }
      })
      return documentosData
    },
    setCategoriaNome (id) {
      DocumentoService.getCategoria(id)
      .then(categoria => {
        this.titulo = categoria.data.name
      })
      .catch(() => {
        const titulo = this.$route.params.slug
            .split('-')
            .map(str => `${str[0].toUpperCase()}${str.slice(1)}`)
            .join(' ')
        this.titulo = titulo
      })
      .finally(() => {
        this.$emit('updateHead')
      })
    }
  },
  mounted: function () {
    this.categoria = (this.$route.params.slug) ? this.$route.params.slug : 0
    this.arquivos = this.loadDocumentos(this.categoria)
  },
  head: {
    title () {
      return {
        inner: `${this.$SITE_TITLE} - ${this.titulo}`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Arquivos.vue?27dd04ac